import { render, staticRenderFns } from "./DragAndDropMultipleLists.vue?vue&type=template&id=67e36fa6&scoped=true&"
import script from "./DragAndDropMultipleLists.vue?vue&type=script&lang=js&"
export * from "./DragAndDropMultipleLists.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDropMultipleLists.vue?vue&type=style&index=0&id=67e36fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e36fa6",
  null
  
)

export default component.exports